// extracted by mini-css-extract-plugin
export default {"loaderParent":"Loader_loaderParent__C59yf","loadergif":"Loader_loadergif__UwR1p","loader":"Loader_loader__XEpit","spin":"Loader_spin__jnorr"};